import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCB_API, PREFIX_SCC_API, PREFIX_BIGYUER_API } from '@/service'

const api = {
  index: `${utils.hostname('cms')}/publish/999/reconsitution.json`,
  businessList: PREFIX_BIGYUER_API + 'getYuerBusinessByCitycode',
  businessName: PREFIX_BIGYUER_API + 'isExistByBusinessName',
  spuListByCate:
    PREFIX_SCC_API + 'fchild/worker/querySpuByCityAndOtherLevel4Category.do'
}

export default {
  /* eslint-disable */
  async getCMSData({commit}) {
    try {
      const settings = await fetch(api.index)
      const settingsJson = await settings.json()
      console.log('cms', settingsJson.data || {})
      return settingsJson.data || {}
    } catch (e) {
      console.log(e)
    }
  },
  async getGoodListData({commit}, param) {
    try {
      await fetch(
        `${api.spuListByCate}?cityId=${
          param.cityCode
        }&isSelf=${param.isSelf}&level4CategoryId=${
          param.categoryId
        }&pageIndex=${param.pageIndex}&pageSize=${
          param.pageSize
        }&districtId=${param.districtId || ''}`,
      )
        .then(res => {
          return res.json()
        })
        .then(result => {
          let {data} = result
          console.log('商品列表', data)
          commit('setGoodList', data)
        })
    } catch (e) {}
  },
  async getRasier({ commit }, param) {
    try {
      await fetch(PREFIX_SCC_API + 'fchild/worker/queryServiceWorker.do', {method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
        body: param
      }).then(res => {
          return res.json()
      }).then(res => {
        let {data} = res
        // console.log('认证育儿师', res.data)
        commit('setRaiserList', data)
        })
    } catch (error) {

    }
  },
  async getmenuList({commit}, param) {
    try {
      await fetch(
        PREFIX_SCC_API + 'fchild/applyJoin/queryCategorys.do',
      )
        .then(res => {
          return res.json()
        })
        .then(result => {
          console.log('caidan列表', result.data)
          let {data} = result
          commit('setMenuList', data)
        })
    } catch (e) {}
  },
  async getConsultantList({commit}, param) {
    try {
      await fetch(
        `${PREFIX_SCC_API}fchild/worker/queryWorkerAndSpuList.do?categoryIds=${param.categoryId}&cityId=${param.cityCode}&pageIndex=${param.pageIndex}&pageSize=${param.pageSize}&sort=${param.sort}&storeCode=${param.entity}`,
      )
        .then(res => {
          return res.json()
        })
        .then(result => {
          let {data} = result
          commit('setConsultantList', data)
        })
        .catch(e => {
          console.log('报错', e)
        })
    } catch (e) {
      console.log('baocuo', e)
    }
  },
  async getShopkeeperList({commit}, param) {
    try {
      await fetch(
        `${PREFIX_SCB_API}business/queryBusinessAndSpuList.do?categoryIds=${param.categoryId}&isSelf=${param.isSelf}&cityId=${param.cityCode}&pageSize=${param.pageSize}&pageIndex=${param.pageIndex}`,
      )
        .then(res => {
          return res.json()
        })
        .then(result => {
          commit('setShopkeeperList', result)
          console.log('shanghu ', result)
        })
    } catch (e) {}
  },
  async getBusinessListByCity({commit}, {gbCode}) {
    const query = queryString.stringify({gbCode})
    const res = await fetch(`${api.businessList}?${query}`)
    const json = await res.json()
    return json.content && json.content.list
  },
  async getCateOrCitySkus(
    {commit},
    {citycode, binary, pageSize, pageLength, districtId, isSelf, businessId},
  ) {
    try {
      const query = queryString.stringify({
        cityId: citycode || '',
        level4CategoryId: binary || '',
        pageIndex: pageSize,
        pageSize: pageLength,
        districtId: districtId || '',
        isSelf,
        businessId,
      })
      const res = await fetch(`${api.spuListByCate}?${query}`)
      const resJson = await res.json()
      if (resJson.code === '1') {
        if (pageSize === 1) {
          commit('resetServiceListByCate')
        }
        commit('setServiceListByCate', resJson.data || [])
      }
      return resJson
    } catch (e) {
      console.log(e)
    }
  },
  async getAreaList({commit}, param) {
    const areaList = await fetch(
      `//address.cekid.com/addressview/GetDistrictList?cityId=${param.cityId}`,
    )
    const areaListData = await areaList.json()
    return areaListData.DistrictList || []
  },
  async getShopkeeperDetail({commit}, param) {
    const data = await fetch(
      `${PREFIX_SCB_API}business/queryFchildBusinessInfo.do?businessId=${param.businessId}`,
    )
    const jsonData = await data.json()
    return jsonData.data || {}
    // .then(result => {
    //   return result.data
    //   // commit('setShopkeeperDetail', result.data)
    //   console.log('商户详情', result.data)
    // })
  },
  async getStoreList({commit}, param) {
    const data = await fetch(
      `//activity.cekid.com/activity/storeO2O/queryStoreofActivityList.do?city_code=${param.cityCode}`,
    )
      .then(res => {
        return res.json()
      })
      .then(result => {
        console.log('门店列表', result)
        commit('setStoreList', result.data)
      })
  },
  async getCommentList({commit}, param) {
    const a = await fetch(
      `//cmt.cekid.com/v1/czjyuer/comment/search/object?object_id=${
        param.id
      }&has_image=1&page=${param.pageIndex || 1}&size=${param.pageSize || 10}`,
    )
      .then(res => {
        return res.json()
      })
      .then(result => {
        commit('setCommentList', result.data)
      })
  },
}
